module.exports = __webpack_public_path__ + "static/appDemo01-1d6899e597b00c03e74b02bc36b32d31.png";